export const workMail = 'work@charrette.club';
export const contactMail = 'bonjour@charrette.club';
export const phoneNb = '0756811122';
